// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a5b6c2c4","455":"c25ce41d","977":"71aa3e87"}[chunkId] + ".chunk.js";
};